<template>
  <div class="home" >
    <!-- 点击显示客服微信二维码 -->
    <div class="appoint_imm" @click="showWxCrad()">
      <!-- <div>立即预约</div> -->
    </div>
    <show-assisant ref="assisant"></show-assisant>
  </div>
</template>
<script>
//引入微信sdk
// const wx = require('weixin-js-sdk');
import { ShareSign } from "@/http/api";
//引入弹出客服微信的组件
import showAssisant from "./showAssiant.vue";
export default {
  components: {
    showAssisant,
  },
  props: {
    isShow:Boolean,
  },
  data() {
    return {
      param: {},
      //切换到页面的路径
      path: "",
    };
  },
  created() {
    this.navigateToWx();
    //引入导师id
    console.log("daskjdahskjdbnmznxcbjkzscduiais");
    this.$bus.$on("getGuilderId", (res) => {
      this.path = "pages/teacherDetail/detail?id=" + res.id;
      // this.path = 'pages/teacherDetail/detail?id=4a5179f3-ed71-4cf7-92f1-c95cfe22fc7c'
      console.log(this.path);
    });
  },
  methods: {
    //  点击显示客服微信二维码
    showWxCrad() {
      this.$refs.assisant.letShow();
    },
    printMes() {
      console.log(123);
    },
    async navigateToWx() {
      let param = {
        pay_type: "member",
        // member
        amount: 0,
      };
      let chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let nonceStr = "";
      for (var i = 0; i < 5; i++) {
        nonceStr += chars.charAt(Math.floor(Math.random() * 62));
      }

      let param2 = JSON.stringify({
        timestamp: Math.floor(new Date().getTime() / 1000), // 必填，生成签名的时间戳
        noncestr: nonceStr, // 必填，生成签名的随机串
        url: window.location.href.split("#")[0],
      });
      //将参数储存到param中
      this.param = param2;
      ShareSign(param2).then((res) => {
        console.log("我是大傻逼哈哈哈");
        console.log(res.data);
        let data = res.data;
        console.log(wx);
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: localStorage["site_current_app_id"]
            ? localStorage["site_current_app_id"]
            : "wx65cb2c350a5f35f3", // 必填，公众号的唯一标识
          // appId:'wx4b41153d6a5e9f20',
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.noncestr, // 必填，生成签名的随机串
          signature: data.sign, // 必填，签名
          openTagList: ["wx-open-launch-weapp"],
          jsApiList: [
            "onMenuShareAppMessage",
            "onMenuShareTimeline",
            "checkJsApi",
            "scanQRCode",
            "chooseImage",
            "previewImage",
            "wx-open-launch-weapp",
          ], //'updateAppMessageShareData','updateTimelineShareData' 必填，需要使用的JS接口列表
        });
        wx.ready(function () {
          console.log("初始化完毕可以点击");
        });
        wx.error(function (err) {
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          console.log("err44444444", err);
        });
      });
    },
    handleLaunchFn(e) {
      console.log("success", e);
    },
    handleErrorFn(e) {
      console.log("fail", e.detail);
    },
  },
};
</script>
<style scoped>
.appoint_imm {
    position: absolute;
    z-index: 99;
    text-align: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 89vw;
    height: 20vw;
    bottom: 11vw;
    right: 6vw;
}
</style>